export const AUTH0_ERROR = {
    TIMEOUT: 'Timeout',
    POPUP_CLOSED: 'Popup closed',
}

export const EXISTING_AUTH_COOKIE_NAME = 'auth0.is.authenticated'
export const EXISTING_AUTH_COOKIE_VALUE = 'true'

export const AUTH_BROADCAST_CHANNEL_NAME = 'authenticationState'
